export enum AnalyzeViews {
  ASSET_OVERVIEW = 'overview',
  SCENARIO = 'scenario',
  CHART = 'chart',
  POSITIONS = 'positions',
}
